import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Case } from '../../../../../../../../_base-shared/models/Case/Case';
import { MainGlobalEventService } from '../../../../../_shared/services/main-global-event.service';
import { CaseService } from '../../../case.service';

@Component({
  selector:    'app-case-document-list-v3-wrapper',
  templateUrl: './case-document-list-v3-wrapper.component.html',
  styles:      [],
  standalone:  false
})
export class CaseDocumentListV3WrapperComponent implements OnInit, OnDestroy {
  public case: Case;
  public caseId: number;
  public caseUuid: string;
  public isLoading                      = 0;
  private subscriptions: Subscription[] = [];
  private pageType: 'admin';

  constructor(private route: ActivatedRoute,
              private caseService: CaseService,
              public globalEventsService: MainGlobalEventService) {
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.pageType = data.pageType;

      if (this.pageType === 'admin') {
        this.route.parent.parent.parent.paramMap.subscribe(params => {
          this.caseId = +params.get('id');
          console.log('document list wrapper caseId ' + this.caseId);
          this.fetchCase(this.caseId);
        });
      }

    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private fetchCase(caseId: number): void {
    this.isLoading++;
    this.subscriptions.push(
      this.caseService.get(caseId, ['contracts']).pipe(finalize(() => this.isLoading--))
        .subscribe(result => this.case = result.data));
  }

}
